module.exports = __webpack_public_path__ + "static/img/ivanchuk.07f2d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/ivanchuk.jpg
// module id = 471
// module chunks = 10